export const contato = {
  email: "contato@precatoriosbrasil.com",
  telefone1: "(11) 4090-1434"
};

export const phoneRemoveMask = (value: string) => value.replace(/\(|\)|\-| /gi, "");


// WEBPACK FOOTER //
// ./src/util/constants.ts